import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HelpDocsRoutingModule } from './help-docs-routing.module';
import { HelpDocsComponent } from './help-docs.component';
import { HelpDocsResolver } from './shared/help-docs.resolver';

/**
 * @export
 * @class LocoModule
 */
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CoreModule,
        OverlayPanelModule,
        DropdownModule,
        AutoCompleteModule,
        InputMaskModule,
        DialogModule,
        SplitButtonModule,
        RadioButtonModule,
        CheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        HelpDocsRoutingModule
    ],
    providers: [HelpDocsResolver],
    declarations: [HelpDocsComponent],
    exports: [HelpDocsComponent]
})
export class HelpDocsModule { }
